<template>
	<div class="web__line">
		<div class="web__container">
			<div class="box-slider">
				<div id="js-slider-homepage" class="box-slider__in">
					<div class="box-slider__item">
						<a href="http://www.shopsys.cz/">
							<picture>
								<source media="(max-width: 1023px)"
									srcset="http://frontend-api.loki.shopsys.com/content/images/sliderItem/default/additional_0_59.jpg" />
								<img alt="" title=""
									src="http://frontend-api.loki.shopsys.com/content/images/sliderItem/default/59.jpg"
									class="image-sliderItem" itemprop="image" />
							</picture>
						</a>
					</div>
					<div class="box-slider__item">
						<a href="https://twitter.com/ShopsysFW">
							<picture>
								<source media="(max-width: 1023px)"
									srcset="http://frontend-api.loki.shopsys.com/content/images/sliderItem/default/additional_0_60.jpg" />
								<img alt="" title=""
									src="http://frontend-api.loki.shopsys.com/content/images/sliderItem/default/60.jpg"
									class="image-sliderItem" itemprop="image" />
							</picture>
						</a>
					</div>
					<div class="box-slider__item">
						<a href="http://www.pojdtesnamirust.cz/">
							<picture>
								<source media="(max-width: 1023px)"
									srcset="http://frontend-api.loki.shopsys.com/content/images/sliderItem/default/additional_0_61.jpg" />
								<img alt="" title=""
									src="http://frontend-api.loki.shopsys.com/content/images/sliderItem/default/61.jpg"
									class="image-sliderItem" itemprop="image" />
							</picture>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Slider'
	}
</script>
